import { Component } from '@angular/core'
import { CellComponent } from '@spartacus/organization/administration/components'

@Component({
    selector: 'eb-order-history-table-link',
    templateUrl: './eb-order-history-table-link.component.html',
    styleUrls: ['eb-order-history-table-link.component.scss'],
    standalone: false
})
export class EbOrderHistoryTableLinkComponent extends CellComponent {}
